
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import PreschoolPerformancesContent from "./components/PreschoolPerformancesContent.vue";

export default defineComponent({
  name: "PreschoolPerformancesView",
  components: {
    BreadCrumb,
    PreschoolPerformancesContent,
  },
});
